<template>
    <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                           :titleLabel="$t('profile.label.pic_phone')"
                           :parentScreen="parentScreen">
        <div class="form-group row">
            <label class="control-label col-md-3 col-form-label" for="picPhone">
            </label>
            <div class="col-md-6">
                <input
                        type="text"
                        class="form-control"
                        v-model="$v.input['amsCustomerDetail.picPhone'].$model"
                        id="picPhone"
                        name="picPhone"
                        required
                        maxlength="11"
                        v-numbers-only
                        v-convert-fullwidth-to-halfwidth>
                <div v-if="$v.input['amsCustomerDetail.picPhone'].$error || $v.input['amsCustomerDetail.picPhone'].$anyError" class="error-messages ng-active">
                    <div v-if="!$v.input['amsCustomerDetail.picPhone'].required">
                        {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.pic_phone')}) }}
                    </div>
                    <div v-if="$v.input['amsCustomerDetail.picPhone'].required && !$v.input['amsCustomerDetail.picPhone'].phoneNumberValidation ">
                        {{ $t('profile.update.error.phone.invalid') }}
                    </div>
                </div>
            </div>
        </div>
        <template v-if="this.isParentScreenEditProfile">
            <div class="form-action">
                <button class="btn btn-sm btn-submit btn-success mr-2"
                        :disabled="isDisabledButtonSubmit"
                        :type="this.getButtonType()">
                    {{$t('profile.button.submit')}}
                </button>
                <button class="btn btn-default btn-cancel btn-sm"
                        type="button"
                        @click="reverseInput">
                    {{$t('profile.button.cancel')}}
                </button>
            </div>
        </template>
    </ForceNewsBlockWrapper>
</template>
<script>
    /**
     * @author HungNS
     */
    import formMixin from '@/common/mixins/form';
    import {required} from 'vuelidate/lib/validators'
    import {phoneNumberValidation} from '@/common/helpers/validation'

    export default {
        name: "UpdatePicPhone",
        props: {},
        mixins: [formMixin],
        methods: {},
        validations() {
            return {
                input: {
                    'amsCustomerDetail.picPhone': {
                        required,
                        phoneNumberValidation
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
